import { render, staticRenderFns } from "./FormElementLongTextInput.vue?vue&type=template&id=629f6f79&scoped=true"
import script from "./FormElementLongTextInput.vue?vue&type=script&lang=js"
export * from "./FormElementLongTextInput.vue?vue&type=script&lang=js"
import style0 from "./FormElementLongTextInput.vue?vue&type=style&index=0&id=629f6f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f6f79",
  null
  
)

export default component.exports